var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHistoryCreate = function SvgHistoryCreate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.85,
    d: "M13.75 13.063H2.25a.5.5 0 0 0-.5.5v.562c0 .069.056.125.125.125h12.25a.125.125 0 0 0 .125-.125v-.562a.5.5 0 0 0-.5-.5M4.027 11.75a1 1 0 0 0 .093-.008l2.628-.46a.15.15 0 0 0 .083-.044l6.624-6.624a.155.155 0 0 0 0-.22l-2.597-2.599a.16.16 0 0 0-.111-.045.16.16 0 0 0-.111.045L4.013 8.42a.16.16 0 0 0-.044.083l-.461 2.628a.52.52 0 0 0 .147.465.53.53 0 0 0 .372.155"
  })));
};
export default SvgHistoryCreate;